import React, { useState } from 'react';
import { Image as AntdImage } from 'antd';
import ImagePlaceholder, {
  ReactComponent as Empty,
} from 'assets/img/placeholder/image_placeholder.svg';

const EMPTY_IMAGE = {
  default: ImagePlaceholder,
};

export default function Image({ fallback, ...props }) {
  const [error, setError] = useState(false);
  return (
    <AntdImage
      fallback={typeof fallback === 'undefined' ? EMPTY_IMAGE.default : fallback}
      onError={() => {
        setError(true);
      }}
      {...props}
      src={props.src || 'error'}
    />
  );
}

Image.EMPTY_IMAGE = EMPTY_IMAGE;
